import React, { useRef } from "react";
import {
  BellRinging,
  CopyIcon,
  FormCheckboxButton,
  LinkIcon,
  MailIcon,
  MessagesIcon,
  More_horiz,
  PencilIcon,
  PeopleIcom,
  ScreenShare,
  TrashIcon,
  XIcon,
} from "../utils/icons";
import { Avatar, Tooltip } from "antd";
import MyModal from "./CustomModal/Modal";
import avatarImage from "../assets/images/Female08.png";
import { useSelector } from "react-redux";
import dayjs from "dayjs";
import { Link } from "react-router-dom";
import toastMessage from "../utils/toastMessage";

function DeleteEventsModal({
  data,
  isDeleteModalVisible,
  confirmDeletion,
  cancelDeletion,
  editModal,
  handleEdit,
}) {
  const userList = useSelector((state) => state.user.userList) || [];

  const filterUserList = userList?.filter((items) =>
    data?.event._def.extendedProps.users?.includes(items.PK.S)
  );

  const start = dayjs(data?.event._instance.range.start).utc();
  const end = dayjs(data?.event._instance.range.end).utc();
  const startFormat = start.format("dddd, MMMM D | h:mm a");
  const endFormat = end.format("h:mm a");
  // Combine for the final display
  const displayFormat = `${startFormat} - ${endFormat}`;
  const copyTextRef = useRef();

  const copyTextFunc = () => {
    const text = copyTextRef.current.innerText;
    navigator.clipboard?.writeText(text).then(() => {
      toastMessage("Meeting Link Has been copied successfully", "success");
    });
  };

  const editModalFun = () => {
    cancelDeletion();
    editModal(true);
    console.log(data, "====datatataaatatat");
    handleEdit(data.event._def, data.event._instance);
  };

  return (
    <MyModal
      // width={400}
      // title="Confirm Event Deletion"
      open={isDeleteModalVisible}
      onOk={confirmDeletion}
      onCancel={cancelDeletion}
      closable={false}
      footer={false}
    >
      {/* <p>Are you sure you want to delete this event?</p> */}
      <div className="space-y-8">
        <div className="flex gap-3 justify-end">
          <Link onClick={editModalFun}>
            <PencilIcon />
          </Link>
          <button onClick={confirmDeletion}>
            <TrashIcon />
          </button>
          <More_horiz />
          <button onClick={cancelDeletion}>
            <XIcon />
          </button>
        </div>
        <div className="flex gap-2 items-start">
          <FormCheckboxButton color="red" />
          <div className="-mt-1">
            <h1 className="font-semibold text-lg">{data?.event._def.title}</h1>
            <p className="text-DarkGrey">
              {data?.event._def.extendedProps.description}
            </p>
            <p className="text-DarkGrey">{displayFormat}</p>
          </div>
        </div>
        <div className="flex gap-3">
          <LinkIcon />
          <p className="text-secondary5" ref={copyTextRef}>
            {data?.event._def.extendedProps.meetingLink}
          </p>
        </div>
        <div className="flex items-center gap-3">
          <PeopleIcom />
          <div className="flex justify-between w-full items-center">
            <Avatar.Group>
              {filterUserList.map((items, id) => {
                return (
                  <Tooltip key={id} title={items?.Name.S} placement="top">
                    <Avatar>{items?.Name.S.slice(0, 2)}</Avatar>
                  </Tooltip>
                );
              })}
            </Avatar.Group>
            <div className="flex gap-3">
              <a onClick={copyTextFunc}>
                <CopyIcon />
              </a>
              <Link to={"/communication"}>
                <MessagesIcon />
              </Link>
              {/* <MailIcon /> */}
            </div>
          </div>
        </div>
        <div className="flex gap-3">
          <BellRinging />
          <h1 className="text-DarkGrey font-semibold">10 Min before event</h1>
        </div>
        <div className="flex gap-3">
          <ScreenShare />
          <h1 className="text-DarkGrey">
            {data?.event._def.extendedProps.eventType}
          </h1>
        </div>
      </div>
    </MyModal>
  );
}

export default DeleteEventsModal;
